import AdvancedMap from '../../local_modules/advanced_map'
import {BobTVUser} from '../components/bobtv-neo/BobTVUser/index';

import {
    EXCLUSION_APPLIED_NOTIFICATION,
    GIFT_NOTIFICATION,
    PERSONAL_ROOM_ACTIVATED_NOTIFICATION,
    SHOWROOM_ACTIVATED_NOTIFICATION,
    SERVICE_MESSAGE,
    TIP_NOTIFICATION,
    WALL_POST_NOTIFICATION,
    MEMBERSHIP_GIFT_NOTIFICATION,
    USER_MUTED_NOTIFICATION,
    USER_UNMUTED_NOTIFICATION
} from '../constants/serviceMessage';

import {LOGIN_SUCCESS} from '../constants/general';
import {
    MESSAGE_GENERAL,
    ROOM_MESSAGE,
    STATUS_MOTD,
    MESSAGE_MOTD
} from '../constants/roomMessages';

import {
    ROOM_DESTROYED,
    ROOM_JOINED,
    ROOM_LEAVED,
    ROOM_LIST,
    ROOM_STAYED,
    ROOM_TYPE_PERSONAL,
    ROOM_USER_SORTING_UPDATED,
    VISIBLE_ROOM_SWITCHED
} from '../constants/rooms';

import {
    getUserSorting,
    ROOM_CLIENT_LIST,
    ROOM_CLIENT_LOGIN,
    ROOM_CLIENT_LOGOUT,
    ROOM_CLIENT_UPDATE,
    ROOM_CLIENT_UPDATE_OFFLINE
} from '../constants/users'

import {
    STREAM_WATCHER_COUNT,
    STREAM_STREAM_UPDATE
} from '../constants/streaming'


import appConfig from '../../app.config';

let {ROOM_HISTORY_LIMIT} = appConfig;

function emptyRoom(roomid) {
    return {
        roomid: roomid,
        info: {},
        users: new AdvancedMap(),
        messages: [],
        active: false,
        visible: false,
        stayed: false,
        watcherCount: {}
    }
}

function checkForChangeWatcherCounts(state, newState) {
    let ufrag;
        for (ufrag in state) {
            // entry deleted
            if (!newState.hasOwnProperty(ufrag)) return newState;
            // entry changed
            if (newState[ufrag] !== state[ufrag]) return newState;
        }

        for (ufrag in newState) {
            // entry added
            if (!state.hasOwnProperty(ufrag)) return newState;
        }
    return state;
}

function getRoomFromState(roomid, state) {
    return state[roomid] ? state[roomid] : emptyRoom(roomid)
}

function addMessageToRoom(room, message) {
    const historyLimit = ROOM_HISTORY_LIMIT;
    // Do slice once per every 10 messages
    let slice = room.messages.length >= historyLimit + 10
        ? room.messages.slice(10)
        : room.messages;

    //let messages = room.messages;
    let newRoom = { ...room };

    if (!room.messages.some(roomMessage => roomMessage.id === message.id)) {
        newRoom = {
            ...room,
            unreadMessages: !room.visible,
            messages: [
                ...slice,
                message
            ]
        };
    }

    return newRoom;
}

function roomReducer(room = {}, action, fullState) {

    if (action.type === ROOM_JOINED) {
        return {
            ...room,
            active : true
        }
    }

    if (action.type === ROOM_STAYED) {
        return {
            ...room,
            stayed : true
        }
    }

    if (action.type === ROOM_LEAVED) {
        let newRoom = emptyRoom(room.roomid);
        newRoom.info = room.info;
        return newRoom;
    }
    
    if (action.type === SERVICE_MESSAGE && action.message.type === TIP_NOTIFICATION) {
        let message = {
            id: 'tip_notification_'+action.message.data.id,
            type: TIP_NOTIFICATION,
            message: action.message.data
        };

        return addMessageToRoom(room, message);
    }

    if (action.type === SERVICE_MESSAGE && action.message.type === GIFT_NOTIFICATION) {
        let message = {
            id: action.message.data.id,
            type: GIFT_NOTIFICATION,
            message: action.message.data
        };
        return addMessageToRoom(room, message);
    }

    if (action.type === SERVICE_MESSAGE && action.message.type === WALL_POST_NOTIFICATION) {
        let message = {
            id: 'wall_post_'+action.message.data.id,
            type: WALL_POST_NOTIFICATION,
            message: action.message.data
        };

        return addMessageToRoom(room, message);
    }

    if (action.type === SERVICE_MESSAGE && action.message.type === MEMBERSHIP_GIFT_NOTIFICATION) {
        let message = {
            id: 'wall_post_'+action.message.data.id,
            type: MEMBERSHIP_GIFT_NOTIFICATION,
            message: action.message.data
        };

        return addMessageToRoom(room, message);
    }

    if (action.type === SERVICE_MESSAGE && action.message.type === EXCLUSION_APPLIED_NOTIFICATION) {
        let message = {
            id: 'exclusion_applied_'+action.message.data.nick,
            type: EXCLUSION_APPLIED_NOTIFICATION,
            message: action.message.data
        };

        return addMessageToRoom(room, message);
    }

    if (action.type === SERVICE_MESSAGE && action.message.type === PERSONAL_ROOM_ACTIVATED_NOTIFICATION) {
        let message = {
            id: 'personal_room_activated_'+action.message.data.roomid,
            type: PERSONAL_ROOM_ACTIVATED_NOTIFICATION,
            message: action.message.data
        };

        return addMessageToRoom(room, message);
    }

    if (action.type == SERVICE_MESSAGE && action.message.type == SHOWROOM_ACTIVATED_NOTIFICATION) {
        let message = {
            id: 'showroom_activated_'+action.message.data.roomid,
            type: SHOWROOM_ACTIVATED_NOTIFICATION,
            message: action.message.data
        }

        return addMessageToRoom(room, message);
    }

    if (action.type === SERVICE_MESSAGE &&
        (action.message.type === USER_MUTED_NOTIFICATION || action.message.type === USER_UNMUTED_NOTIFICATION)) {
        let message = {
            id: 'user_censored_'+Date.now(),
            type: action.message.type,
            message: action.message.data
        };

        return addMessageToRoom(room, message);
    }

    if (action.type === STATUS_MOTD) {
        let message = {
            id: 'motd',
            type: MESSAGE_MOTD,
            message: action.data.motd
        };

        return addMessageToRoom(room, message);
    }

    if (action.type === ROOM_MESSAGE) {
        let {message, ...rest} = action;
        message = {
            id: message.mid,
            type: MESSAGE_GENERAL,
            message,
            ...rest
        };

        return addMessageToRoom(room, message);
    }

    if (action.type === ROOM_CLIENT_LIST) {
        let newWCState = action.list.reduce(function(acc, cur) { return {...acc, [cur.ufrag]: cur.watcher_count} }, {});

        let ret = new AdvancedMap();

        for (let index in action.list) {
            let user = action.list[index];
            ret.set({ufrag: user.ufrag, nick: user.nick}, user);
        }

        if(fullState.userSorting) {
            ret.sort(getUserSorting(fullState));
        }

        let newRoom = {
            ...room,
            watcherCount: checkForChangeWatcherCounts(room.watcherCount, newWCState),
            users: ret
        };
        return newRoom;

    }

    if (action.type === ROOM_CLIENT_LOGIN) {
        let ret = new AdvancedMap(room.users);
        ret.delete({nick: action.user.nick});
        ret.set({ufrag: action.user.ufrag, nick: action.user.nick}, action.user);

        return {
            ...room,
            users: ret
        }
    }

    if (action.type === ROOM_CLIENT_UPDATE) {
        // Update sorting callback here as client_update may come for the currentUser and new user object may contain parameters affecting sorting (followees)
        let ret = new AdvancedMap(room.users, getUserSorting(fullState));
        ret.set({ufrag: action.user.ufrag, nick: action.user.nick}, action.user);

        const msgs = room.messages.map(msg => {
            if (msg.user && msg.user.uid === action.user.uid) {
                msg.user = action.user;
                return msg;
            }
            return msg;
        })

        return {
            ...room,
            users: ret,
            messages: msgs
        }
    }

    if (action.type === ROOM_CLIENT_UPDATE_OFFLINE) {
        const msgs = room.messages.map(msg => {
            if (msg.user && msg.user.uid === action.user.uid) {
                msg.user = action.user;
                msg.user.updated_offline = true;
                return msg;
            }
            return msg;
        })
        return {
            ...room,
            messages: msgs
        }
    }

    if (action.type === ROOM_CLIENT_LOGOUT) {
        var ret = new AdvancedMap(room.users);
        ret.delete({ufrag: action.user.ufrag});

        return {
            ...room,
            users: ret
        }
    }

    if (action.type === STREAM_WATCHER_COUNT) {
        let newWCState = action.data.reduce(function(acc, cur) { return {...acc, [cur.ufrag]: cur.watcher_count} }, {});

        return {
            ...room,
            watcherCount: checkForChangeWatcherCounts(room.watcherCount, newWCState)
        }
    }


    if (action.type === STREAM_STREAM_UPDATE) {
        let ret = new AdvancedMap(room.users, getUserSorting(fullState));
        let newWCState = {};
        

        for (let index in action.data) {
            let streamData = action.data[index];
            let user = ret.get({ufrag: streamData.ufrag});
            if (!user) continue;
            let stream = user.streams[streamData.stream_id];
            let newStream = {
                ...stream,
                watcher_count: streamData.watcher_count
            }
            let newStreams = {
                ...user.streams
            }
            newStreams[index] = newStream;
            let newUser = new BobTVUser({
                ...user,
                streams: newStreams
            })
            ret.set({ufrag: user.ufrag, nick: user.nick}, newUser);
            // newWCState[index] = action.data[index].watcher_count;
            // ret.set({ufrag: user.ufrag, nick: user.nick}, user);
        }
        let newRoom = {
            ...room,
            users: ret
        };

        return newRoom;

    }

    return room;
}

export default function rooms(state = {}, action, fullState) {
    if (action.type === LOGIN_SUCCESS) {
        let newState = {};
        newState[action.room.roomid] = emptyRoom(action.room.roomid);
        newState[action.room.roomid].info = action.room;
        newState[action.room.roomid].active = true;
        newState[action.room.roomid].stayed = true;
        newState[action.room.roomid].visible = true;
        return newState;
    }

    if (action.type === ROOM_LIST) {
        //let list = action.list.filter((info) => info.type != ROOM_TYPE_PERSONAL);
        let list = action.list;
        let newState = {};

        for (let info of list) {
            let oldRoom = getRoomFromState(info.roomid, state);

            newState[info.roomid] = {
                ...oldRoom,
                info: info
            }
        }

        for (let roomid in state) {
            if (newState.hasOwnProperty(roomid)) {
                continue;
            }
            let oldRoom = state[roomid];
            if (oldRoom && (oldRoom.active || oldRoom.visible)) {
                newState[roomid] = oldRoom;
            }
        }

        return newState;
    }

    if (action.type === VISIBLE_ROOM_SWITCHED) {
        let newRoomid = action.room.roomid;
        let newState = {};

        for (let oldRoomid in state) {
            let oldRoom = getRoomFromState(oldRoomid, state);

            if (oldRoom.visible) {
                newState[oldRoom.roomid] = {
                    ...oldRoom,
                    unreadMessages: false,
                    visible: false
                }
            } else if (oldRoom.roomid === newRoomid) {
                newState[oldRoom.roomid] = {
                    ...oldRoom,
                    unreadMessages: false,
                    visible: true
                }
            } else {
                newState[oldRoom.roomid] = oldRoom;
            }
            
        }

        return newState;
    }

    if (action.type === SERVICE_MESSAGE) {
        if (action.message.roomid) {
            action.roomid = action.message.roomid;
        } else {
            let newState = {...state};
            for (let roomid in state) {
                let room = getRoomFromState(roomid, state);
                if (room.active) {
                    newState[roomid] = roomReducer(room, action, fullState);
                }
            }
            return newState;
        }
    }

    if (action.type === ROOM_USER_SORTING_UPDATED) {
        let rooms = state;
        let current_room_id = fullState.visibleChatrooms.roomid;

        if(!rooms.hasOwnProperty(current_room_id)) {
            return state;
        }

        let room = rooms[current_room_id];
        let users = new AdvancedMap(room.users);

        if(action.sorting) {
            let newState = {...fullState, userSorting: action.sorting};
            users.sort(getUserSorting(newState));
        }

        rooms[current_room_id] = {
            ...room,
            users: users
        };

        return rooms;
    }

    if (action.roomid) {
        let room = getRoomFromState(action.roomid, state);
        let newRoom = roomReducer(room, action, fullState);
        if (newRoom === room) {
            return state;
        }
        let newState = {
            ...state
        };
        newState[action.roomid] = newRoom;
        return newState;
    }

    // todo: handle this action
    if (action.type === ROOM_DESTROYED) {

    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/rooms.js